import { merge } from "@awe-web/shared/lib";
import { loadFormConfiguration, serverValidationFailed, toIsoString, dateStringToDateTime } from "@awe-web/shared/lib";
import { updateUserProfile } from "../../../user/actions.js";
import { MyBmwRentProfileSuccess } from "../../../routing/routes.js";
import { newMapFormValues } from "@awe-web/shared/lib";

export const initialize = () => async (dispatch, getState, context) => {
  const captchaSiteKey = await context.api.user.getCaptchaSiteKey();
  await dispatch({
    type: "USER/CAPTCHA_SITEKEY_LOADED",
    payload: {
      captchaSiteKey: captchaSiteKey
    }
  });

  await dispatch(loadFormConfiguration("privateChangeUserDataFSD"));
};

const normalizeDate = value => toIsoString(dateStringToDateTime(value));

export const submit = (formValues, { setSubmitting, validateForm }) => async (dispatch, getState) => {
  const mapFormValues = newMapFormValues("privateChangeUserDataFSD")(getState());
  const normalizedValues = mapFormValues(merge(formValues, {
    "Driver:birthdate": normalizeDate(formValues["Driver:birthdate"]),
    "Driver:identCardIssued": normalizeDate(formValues["Driver:identCardIssued"]),
    "Driver:identcardValidTill": normalizeDate(formValues["Driver:identcardValidTill"]),
    "Driver:licenceDateIssued": normalizeDate(formValues["Driver:licenceDateIssued"])
  }));

  try {
    setSubmitting(true);
    await dispatch(updateUserProfile(normalizedValues));
    return MyBmwRentProfileSuccess.path();
  }
  catch (error) {
    if (error.type === "VALIDATION_FAILED") {
      const groupName = "privateChangeUserDataFSD";
      const errors = error.errors;
      dispatch(serverValidationFailed(groupName, formValues, errors));
      setTimeout(() => {
        validateForm();
      }, 200);
      return;
    }

    throw error;
  }
  finally {
    setSubmitting(false);
  }
};
